import MuiAvatar from '@mui/material/Avatar'

import { Collar } from '#/components/FormatCell/Types/AvatarLink'
import { Icon } from '#/components/Icon'
import { usePermissions } from '#/store/ducks/permissions'
import Colors from '#/styles/Colors'

type AvatarCellProps = {
  collar?: Collar
  discarded?: boolean
}

function AvatarAnimal({ collar, discarded }: AvatarCellProps) {
  const permissions = usePermissions()
  let icon = <Icon size="large" name="animal" sx={{ fontSize: '30px' }} />
  let backgroundColor

  if (collar?.code) {
    backgroundColor = Colors.devices.ctech.normal.backgroundColor
  }

  if (
    collar?.status &&
    (permissions.farm.view_collar_status_report || permissions.system.view_collar_status_report)
  ) {
    backgroundColor = Colors.devices.ctech[collar.status]?.backgroundColor
  }

  if (discarded) {
    icon = <Icon size="large" name="discard" sx={{ fontSize: '30px' }} />
    backgroundColor = undefined
  }

  return <MuiAvatar style={{ backgroundColor }}>{icon}</MuiAvatar>
}

export { AvatarAnimal }
